import { isNil, only, XcoreCore } from "@robe/core";
import { NewsPreview } from "./types";

export const MAX_NEWS_CARDS_COUNT_PER_PAGE = 12;

export const getNews = async (
  core: XcoreCore,
  locale: string,
  { year, category, product, ...pagination }: Record<string, string | string[] | undefined> = {}
) =>
  await core.content.multipleByType<NewsPreview>("news", {
    fields: ["title", "intro", "images", "layout", "thumbnail", "content", "thumbnailIntro", "products"],
    sort: { fieldName: "publishedAt", orderBy: "Descending" },
    ...(locale === "fr" && { locales: ["fr"] }),
    includeCategories: true,
    ...(category && { categories: [Array.isArray(category) ? category.map((c) => +c) : [+category]] }),
    ...(year ? { publishedAt: [`${year as string}-01-01`, `${Number(year as string) + 1}-01-01`] } : {}),
    relations: (Array.isArray(product) ? product : [product]).filter((x) => !isNil(x)).map(Number),
    ...newsPagination(pagination),
  });

const newsPagination = (query: Record<string, string | string[] | undefined>) => {
  const pageQuery = only(query.page);

  return {
    page: 1,
    perPage: pageQuery ? +pageQuery * MAX_NEWS_CARDS_COUNT_PER_PAGE : 15,
  };
};
